<template>
    <div>
        <b-card class="standardpage border-none">
            <b-card-header>
                <b-row>
                    <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
                        <i :class="wfh.icon" class="mr-1"></i>
                        <span>{{ wfh.title }}</span>
                    </b-col>
                </b-row>
            </b-card-header>

            <div v-show="!component" class="availtable datatable">
                <b-card class="w-100pct mb-2">
                    <b-card-body class="py-0">
                        <b-row v-if="!showfilter">
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="Email" label-size="sm" class="">
                                    <b-input-group>
                                        <b-form-input v-model="email" :debounce="wfh.debounce"
                                            placeholder="Email"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!email"
                                                @click="email = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label-cols="12" label="IP" label-size="sm" class="">
                                    <b-input-group>
                                        <b-form-input v-model="ipaddress" :debounce="wfh.debounce"
                                            placeholder="IP"></b-form-input>
                                        <b-input-group-append>
                                            <b-button size="sm" variant="outline-secondary" :disabled="!ipaddress"
                                                @click="ipaddress = ''">
                                                <i class="fa fa-remove"></i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="6" md="4" xl="3">
                                <b-form-group label="IP Ports" label-for="ipports" label-cols="12" label-size="sm">
                                    <treeselect v-model="ipports" :clearable="true" :options="options_ipports"
                                        :multiple="true" :disabled="false">
                                    </treeselect>
                                </b-form-group>
                            </b-col>

                        </b-row>
                    </b-card-body>
                </b-card>
                <div class="px-3">
                    <d-table classdivtable="availtable datatable" refid="wfh" :icon="wfh.icon" :busy="wfh.busy"
                        :toolbarlibrary="wfh.toolbarlibrary" :tools="wfh.tools" :badges="wfh.badges"
                        :fields="wfh.fields" :items="wfh.items" :limit="wfh.limit" :downloaded="wfh.downloaded"
                        :showpages="true" :offset="wfh.offset" :page="wfh.page" @load="wfh_load" @click="wfh_click"
                        @changed="wfh_click('save', $event)" @select="wfh_select">
                    </d-table>
                </div>
            </div>

            <div v-show="component">
                <component :is="component" :selection="wfh.selected" :config="cconfig" @discard="wfh_click('discard')"
                    @go="wfh_click('go')"></component>
            </div>
        </b-card>
    </div>
</template>


<script>
import gql from "graphql-tag";

import WFHEdit from "./Components/WFHEdit";

export default {
    name: "WFH",
    components: { WFHEdit },
    watch: {
        async ipaddress() {
            await this.wfh_load(0);
        },
        async email() {
            await this.wfh_load(0);
        },
        async ipports() {
            await this.wfh_load(0);
        },
    },
    data() {
        return {
            email: null,
            ipaddress: null,
            ipports: [],
            options_ipports: [
                { id: "1433", label: "1433 | SQL Server" },
                { id: "5432", label: "5432 | Postgres" },
                { id: "5000", label: "5000 | RDP Alternate" }
            ],
            wfh: {
                title: "Working From Home",
                icon: "fa fa-home text-purple",
                debounce: 500,
                busy: false,
                page: 1,
                offset: 0,
                limit: 15,
                // updateit
                tools: "go,filter,download,clipboard,edit",
                toolbarlibrary: [
                    // {
                    //     type: "button",
                    //     size: "sm",
                    //     variant: "outline-white",
                    //     squared: "squared",
                    //     icon: "fa fa-cogs text-primary",
                    //     position: "toolbar",
                    //     action: "updateit",
                    //     label: "Update",
                    //     component: {
                    //         name: "",
                    //     },
                    // },
                ],
                fields: [
                    {
                        key: "selected",
                        label: "...",
                        class: "text-center w-25px",
                    },
                    {
                        key: "icon",
                        label: "",
                        class: "text-right w-50px",
                    },
                    {
                        key: "email",
                        label: "Email",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                    },
                    {
                        key: "department",
                        label: "Department",
                        sortable: true,
                        sortDirection: "desc",
                        type: "text",
                    },
                    {
                        key: "ipaddress",
                        label: "IP",
                        sortable: true,
                        type: "text",
                    },
                    {
                        key: "rdp",
                        label: "RDP",
                        sortable: true,
                        type: "text",
                        formatter: (value, key, item) => {
                            let result = ""
                            if (value == 'yes') {
                                result = "<i class='fa fa-laptop text-primary' title='Remote Desktop'></i>"
                            }
                            return result
                        }
                    },
                    {
                        key: "sql",
                        label: "SQL",
                        sortable: true,
                        type: "text",
                        formatter: (value, key, item) => {
                            let result = ""
                            if (value == 'yes') {
                                result = "<i class='fa fa-database text-danger' title='SQL Server'></i>"
                            }
                            return result
                        }
                    },
                    {
                        key: "pg",
                        label: "PG",
                        sortable: true,
                        type: "text",
                        formatter: (value, key, item) => {
                            let result = ""
                            if (value == 'yes') {
                                result = "<i class='fa fa-database text-info' title='PostgreSQL'></i>"
                            }
                            return result
                        }
                    },
                    {
                        key: "updated_by",
                        label: "Updated By",
                        sortable: true,
                        class: "text-center w-100px",
                    },
                    {
                        key: "updated_at",
                        label: "Updated At",
                        sortable: true,
                        class: "text-right w-100px",
                    },
                    {
                        key: "actions",
                        label: "Actions",
                        class: "actions w-100px",
                    },
                ],
                badges: [
                    {
                        key: "ipaddress",
                        type: "pill",
                        class: "white",
                    },
                ],
                items: [],
                selected: [],
                downloaded: [],
                denied: [],
            },
        };
    },
    async mounted() {
        this.accessdenied();
        await this.wfh_load();
    },

    methods: {
        accessdenied() {
            this.wfh.denied = [];
            if (!this.user.permissions.includes("users.delete")) {
                this.wfh.denied.push("deleteconfirm");
            }
            if (!this.user.permissions.includes("users.save")) {
                // this.wfh.denied.push("add");
                this.wfh.denied.push("save");
            }

        },

        async wfh_load(offset, limit, page) {
            let state = this.wfh;

            if (offset || offset == 0) {
                state.offset = offset
            }
            if (limit || limit == 0) {
                state.limit = limit
            }
            if (page) {
                state.page = page
            }

            state.busy = true;

            let variables = {
                offset: state.offset,
                limit: state.limit,
                ipaddress: this.ipaddress,
                iproaming: "1",
                email: this.email,
                ipports: this.ipports.length > 0 ? this.ipports.join(",") : null,
                orderby: [["email", "asc"]],
            };
            console.log("variables", variables);

            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query setup_users(
                            $limit: Int
                            $offset: Int
                            $email: String
                            $ipaddress: String
                            $iproaming: String
                            $ipports: String
                            $orderby: [[String]]                           
                        ) {
                            setup_users(
                            limit: $limit
                            offset: $offset
                            email: $email
                            ipaddress: $ipaddress
                            iproaming: $iproaming
                            ipports: $ipports
                            orderby: $orderby                           
                                ) {
                                id
                                email
                                ipaddress
                                ipports
                                iproaming 
                                ipports                              
                                department                               
                                rows
                                updated_at
                                updated_by
                                }
                            }
            `,
                    variables,
                });

                for (var i = 0; i < response.data.setup_users.length; i++) {
                    if (response.data.setup_users[i].ipports) {
                        if (response.data.setup_users[i].ipports.includes('5000')) {
                            response.data.setup_users[i].rdp = "yes"
                        }
                        if (response.data.setup_users[i].ipports.includes('1433')) {
                            response.data.setup_users[i].sql = "yes"
                        }
                        if (response.data.setup_users[i].ipports.includes('5432')) {
                            response.data.setup_users[i].pg = "yes"
                        }
                    }
                }
                // USE LOCAL VARIABLE              

                state.downloaded = []
                if (limit == 0) {
                    state.downloaded = response.data.setup_users
                } else {
                    state.items = response.data.setup_users;
                }

            } catch (error) {
                console.log(error);
            }

            // await this.setup_users();

            state.busy = false;
        },
        async wfh_click(a, ss) {

            switch (a) {
                case "download_view":
                    state.downloaded = []
                    state.downloaded = state.items
                    break;

                case "download_all":
                    state.downloaded = []
                    await this.wfh_load(0, 0);
                    break;

                case "filter":
                    this.showfilter = !this.showfilter;
                    break;
                case "discard":
                    this.component = null;
                    await this.wfh_load();
                    break;
                case "go":
                    this.component = null;
                    await this.wfh_load();
                    break;
                // case "add":
                case "edit":
                    this.component = "WFHEdit";
                    break;
            }
        },
        async wfh_select(ss, tools) {

            let state = this.wfh;

            state.selected = ss;
            let tool = null;
            // , "updateit"
            if (tools) {
                let enabled = ["back", "save", "go", "filter", "download", "clipboard"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = false;
                    }
                });
                // == 1
                enabled = ["edit"];
                enabled.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.disabled = ss.length == 1 ? false : true;
                    }
                });
                // > 1
                // enabled = ["deleteconfirm"];
                // enabled.forEach(function (action, index) {
                //     tool = tools.find((o) => o.action == action);
                //     if (tool) {
                //         tool.disabled = ss.length > 0 ? false : true;
                //     }
                // });

                if (!state.denied) {
                    state.denied = [];
                }
                state.denied.forEach(function (action, index) {
                    tool = tools.find((o) => o.action == action);
                    if (tool) {
                        tool.visible = false;
                    }
                });
            }
        },

    },
};
</script>

<style></style>